import React from "react";
import ProfileImage from "../../../components/partials/ProfileImage";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import { checkTranslation, translate } from "../../../utils/useful";
import TableViewer from "../../../components/TableViewer";
import FixedView from "../../../components/FixedView";



class AccountsReport extends React.Component {
    state = {
        chart: [
            {
                // img: '/assets/icons/line.svg',
                step: '0',
                Date: 'test'
                // step: '5'
            },
            {
                Date: 'test',
                // img: '/assets/icons/Group 4.svg',
                step: '1'
            },
            {
                Date: 'test',
                // img: '/assets/icons/bar.svg',
                step: '2'
            },
            {
                Date: 'test',
                // img: '/assets/icons/rating.svg',
                step: '3'
            },
            {
                Date: 'test',
                // img: '/assets/icons/table.svg',
                step: '4'
            },
        ],

        headers: [
            { key: 'Date', type: 'TextInput', information: { label: '{{lang}}Date' } },
            { key: 'Transaction Details', type: 'TextInput', information: { label: '{{lang}}Transaction Details' } },
            { key: 'Type', type: 'TextInput', information: { label: '{{lang}}Type' } },
            { key: 'Debit', type: 'TextInput', information: { label: '{{lang}}Debit' } },
            { key: 'Credit', type: 'TextInput', information: { label: '{{lang}}Credit' } },
            // { key: 'cDate', type: 'DateInput', information: { label: 'Creation Date' } },
            // { key: 'restrictions', type: 'TextInput', information: { label: 'Restrictions' } },
        ],
    }
    componentDidMount() {
        setTimeout(() => {
            this.setState({ showFixedView: true })
        }, 200);
    }
    render() {
        return (
            <div>
                <div className="w-100 p-2 flexcb" style={{ background: '#FAFAFA' }}>
                    <div className="flexc">
                        <div className="mrd-2">
                            <p>{translate('Petty Cash')}</p>
                        </div>
                        <div style={{ background: '#eee', padding: '3px 10px', borderRadius: 50 }}>
                            <p style={{ fontSize: 13, color: '#444' }}>{translate('cash')}</p>
                        </div>
                    </div>
                    <div className="d-flex align-items-center"  >
                        <p className="mrd-2" style={{ fontSize: 13 }}>{translate('edit')}</p>
                        <button onClick={() => this.fixedView.showView()}>
                            <div className="mx-3" ref={el => this.nodeRef = el}>
                                {/* <p>upload</p> */}
                                <img src="/assets/icons/applets/drive/share.svg" style={{ width: 18, height: 18 }} />
                            </div>
                        </button>
                    </div>

                </div>
                {this.state.showFixedView && (
                    <FixedView ref={el => this.fixedView = el} nodeRef={this.nodeRef} zIndex={10}>
                        <div className="w-100 px-2 py-3" style={{ background: '#F5F5F5', }}>
                            <p style={{ fontSize: 15, fontWeight: '300' }}>{translate('test')}</p>
                            <p style={{ fontSize: 20, color: '#408dfb' }}>$3,000.00</p>
                            <p style={{ fontSize: 11 }}>{translate('Description : It is a small amount of cash that is used to pay your minor or casual expenses rather than writing a check')}</p>
                        </div>
                    </FixedView>
                )}
                <div className="w-100 px-3 py-3" >
                    <div className=" flexcb" >
                        <div className="flex-1 " >

                            <p style={{ fontSize: 11 }}>{translate("It is a small amount of cash that is used to pay your minor or casual expenses rather than writing a check")}</p>
                        </div>
                        <div className="flex-1 d-flex align-items-end flex-column">

                            <p style={{ fontSize: 15, fontWeight: '300' }}>{translate('Closing Balance')}</p>
                            <div className="mt-2">

                                <p style={{ fontSize: 20, color: '#408dfb' }}>$3,000.00</p>
                            </div>
                        </div>

                    </div>

                </div>
                <div className="mx-3">
                    <div className="my-3">
                        <div style={{ display: 'flex', }}>
                            <p style={{ fontSize: 17 }}>{translate('Recent Transactions')}</p>
                        </div>
                    </div>
                    <div>
                        <TableViewer
                            // isLoading={this.state.isLoading}
                            headers={this.state.headers}
                            data={this.state.chart}
                            // actions={this.state.actions}
                            // settings={{ isSortable: false }}
                            // openEditModal={this.openEditModal}
                            // openRemoveModal={this.openRemoveModal}
                            // updateData={this.updateData}
                            ref={el => this.TableViewer = el}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountsReport);
// export default AccountsReport;